import { FormattedMessage, FormattedNumber } from 'react-intl'

import { IconQuestionMarkCircle } from '@gto/ui/assets'
import { LinearProgress } from '@gto/ui/linear-progress'
import { Typography } from '@gto/ui/typography'

import { useEdgeBalance } from '@/hooks/use-edge-balance'

export const CryptoUnlockProgress = () => {
  const { edgeEarned, edgeToUnlock } = useEdgeBalance()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <Typography variant="h6">
          <FormattedMessage id="edge.premiumRedeem.title" />
        </Typography>
        <Typography
          className="font-semibold"
          color="text.secondary"
          variant="h6"
        >
          <Typography
            className="[font-size:inherit] [font-weight:inherit]"
            color="info.light"
            component="span"
          >
            <FormattedNumber value={edgeEarned} />/
          </Typography>
          <FormattedNumber value={edgeToUnlock} />
        </Typography>
      </div>
      <div className="flex flex-col gap-4">
        <LinearProgress
          color="info"
          size="md"
          value={(edgeEarned / edgeToUnlock) * 100 > 100 ? 100 : (edgeEarned / edgeToUnlock) * 100}
        />

        <Typography
          color="info.light"
          variant="subtitle2"
        >
          <FormattedMessage
            id="edge.premiumRedeem.progress.description"
            values={{
              edge: <FormattedNumber value={edgeToUnlock} />,
            }}
          />
        </Typography>
      </div>
      <div className="flex gap-1.5">
        <IconQuestionMarkCircle width={24} />
        <Typography variant="body3">
          <FormattedMessage id="edge.premiumRedeem.progress.tip" />
        </Typography>
      </div>
    </div>
  )
}
